"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerNavGroup = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DrawerContext_1 = require("../DrawerContext");
var NavGroupContext_1 = require("../NavGroupContext");
var styles_1 = require("@mui/material/styles");
var List_1 = __importDefault(require("@mui/material/List"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var types_1 = require("../types");
var DrawerNavItem_1 = require("../DrawerNavItem");
var DrawerRailItem_1 = require("../DrawerRailItem");
var utilities_1 = require("../utilities");
var css_1 = require("@emotion/css");
var DrawerNavGroupClasses_1 = require("./DrawerNavGroupClasses");
var base_1 = require("@mui/base");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        subheader: ['subheader'],
        title: ['title'],
    };
    return (0, base_1.unstable_composeClasses)(slots, DrawerNavGroupClasses_1.getDrawerNavGroupUtilityClass, classes);
};
var Root = (0, styles_1.styled)(List_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'backgroundColor'; },
})(function (_a) {
    var backgroundColor = _a.backgroundColor;
    return ({
        backgroundColor: backgroundColor,
        paddingBottom: 0,
        paddingTop: 0,
    });
});
var SubHeader = (0, styles_1.styled)(ListSubheader_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        paddingBottom: 0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        position: 'inherit',
        cursor: 'text',
    });
});
var Title = (0, styles_1.styled)(Typography_1.default, {})(function () { return ({
    display: 'block',
    alignItems: 'center',
    lineHeight: '3rem',
    height: "3rem",
    fontWeight: 600,
}); });
var findID = function (item, activeItem) {
    // if leaf node, return
    if (!item.items && !item.children) {
        return item.itemID === activeItem;
    }
    // else, loop through the branches by items
    if (item.items) {
        for (var i = 0; i < item.items.length; i++) {
            if (findID(item.items[i], activeItem)) {
                return true;
            }
        }
    }
    // and by children
    if (item.children) {
        var childItems = (0, utilities_1.findChildByType)(item.children, ['DrawerNavItem']);
        for (var i = 0; i < childItems.length; i++) {
            if (findID(childItems[i].props, activeItem)) {
                return true;
            }
        }
    }
    // no active items found, return false
    return false;
};
var DrawerNavGroupRender = function (props, ref) {
    var defaultClasses = useUtilityClasses(props);
    var theme = (0, styles_1.useTheme)();
    var 
    // Nav Group Props
    children = props.children, classes = props.classes, userClassName = props.className, _a = props.items, items = _a === void 0 ? [] : _a, title = props.title, _b = props.titleColor, titleColor = _b === void 0 ? theme.palette.text.primary : _b, titleContent = props.titleContent, _c = props.titleDivider, titleDivider = _c === void 0 ? true : _c, 
    // Shared Style Props
    activeItemBackgroundColor = props.activeItemBackgroundColor, activeItemBackgroundShape = props.activeItemBackgroundShape, activeItemFontColor = props.activeItemFontColor, activeItemIconColor = props.activeItemIconColor, backgroundColor = props.backgroundColor, chevron = props.chevron, chevronColor = props.chevronColor, collapseIcon = props.collapseIcon, disableActiveItemParentStyles = props.disableActiveItemParentStyles, divider = props.divider, expandIcon = props.expandIcon, hidePadding = props.hidePadding, itemFontColor = props.itemFontColor, itemIconColor = props.itemIconColor, nestedBackgroundColor = props.nestedBackgroundColor, nestedDivider = props.nestedDivider, ripple = props.ripple, otherProps = __rest(props, ["children", "classes", "className", "items", "title", "titleColor", "titleContent", "titleDivider", "activeItemBackgroundColor", "activeItemBackgroundShape", "activeItemFontColor", "activeItemIconColor", "backgroundColor", "chevron", "chevronColor", "collapseIcon", "disableActiveItemParentStyles", "divider", "expandIcon", "hidePadding", "itemFontColor", "itemIconColor", "nestedBackgroundColor", "nestedDivider", "ripple"]);
    var _d = (0, DrawerContext_1.useDrawerContext)(), variant = _d.variant, _e = _d.open, drawerOpen = _e === void 0 ? true : _e, activeItem = _d.activeItem;
    /* Keeps track of which group of IDs are in the 'active hierarchy' */
    var _f = (0, react_1.useState)([]), activeHierarchyItems = _f[0], setActiveHierarchyItems = _f[1];
    /* Clear the active hierarchy array if the new active Item cannot be found in the tree */
    (0, react_1.useEffect)(function () {
        if (!findID({ items: props.items, children: props.children }, activeItem))
            setActiveHierarchyItems([]);
    }, [activeItem]);
    var getChildren = (0, react_1.useCallback)(function () {
        return (0, utilities_1.findChildByType)(children, ['DrawerNavItem', 'DrawerRailItem'])
            // .slice(0, 1)
            .map(function (child) {
            return child.type.displayName === 'DrawerNavItem'
                ? react_1.default.cloneElement(child, {
                    // Inherited Props
                    activeItemBackgroundColor: (0, utilities_1.mergeStyleProp)(activeItemBackgroundColor, child.props.activeItemBackgroundColor),
                    activeItemBackgroundShape: (0, utilities_1.mergeStyleProp)(activeItemBackgroundShape, child.props.activeItemBackgroundShape),
                    activeItemFontColor: (0, utilities_1.mergeStyleProp)(activeItemFontColor, child.props.activeItemFontColor),
                    activeItemIconColor: (0, utilities_1.mergeStyleProp)(activeItemIconColor, child.props.activeItemIconColor),
                    backgroundColor: (0, utilities_1.mergeStyleProp)(backgroundColor, child.props.backgroundColor),
                    chevron: (0, utilities_1.mergeStyleProp)(chevron, child.props.chevron),
                    chevronColor: (0, utilities_1.mergeStyleProp)(chevronColor, child.props.chevronColor),
                    collapseIcon: (0, utilities_1.mergeStyleProp)(collapseIcon, child.props.collapseIcon),
                    disableActiveItemParentStyles: (0, utilities_1.mergeStyleProp)(disableActiveItemParentStyles, child.props.disableActiveItemParentStyles),
                    divider: (0, utilities_1.mergeStyleProp)(divider, child.props.divider),
                    expandIcon: (0, utilities_1.mergeStyleProp)(expandIcon, child.props.expandIcon),
                    hidePadding: (0, utilities_1.mergeStyleProp)(hidePadding, child.props.hidePadding),
                    itemFontColor: (0, utilities_1.mergeStyleProp)(itemFontColor, child.props.itemFontColor),
                    itemIconColor: (0, utilities_1.mergeStyleProp)(itemIconColor, child.props.itemIconColor),
                    nestedBackgroundColor: (0, utilities_1.mergeStyleProp)(nestedBackgroundColor, child.props.nestedBackgroundColor),
                    nestedDivider: (0, utilities_1.mergeStyleProp)(nestedDivider, child.props.nestedDivider),
                    ripple: (0, utilities_1.mergeStyleProp)(ripple, child.props.ripple),
                    depth: 0,
                    isInActiveTree: activeHierarchyItems.includes(child.props.itemID),
                    notifyActiveParent: function (ids) {
                        if (JSON.stringify(activeHierarchyItems) !== JSON.stringify(ids)) {
                            // Sets the list of active IDs when we get a callback from an active child
                            setActiveHierarchyItems(ids.concat(child.props.itemID));
                        }
                    },
                })
                : react_1.default.cloneElement(child, {
                    // Inherited Props
                    activeItemBackgroundColor: (0, utilities_1.mergeStyleProp)(activeItemBackgroundColor, child.props.activeItemBackgroundColor),
                    activeItemFontColor: (0, utilities_1.mergeStyleProp)(activeItemFontColor, child.props.activeItemFontColor),
                    activeItemIconColor: (0, utilities_1.mergeStyleProp)(activeItemIconColor, child.props.activeItemIconColor),
                    backgroundColor: (0, utilities_1.mergeStyleProp)(backgroundColor, child.props.backgroundColor),
                    divider: (0, utilities_1.mergeStyleProp)(divider, child.props.divider),
                    itemFontColor: (0, utilities_1.mergeStyleProp)(itemFontColor, child.props.itemFontColor),
                    itemIconColor: (0, utilities_1.mergeStyleProp)(itemIconColor, child.props.itemIconColor),
                    ripple: (0, utilities_1.mergeStyleProp)(ripple, child.props.ripple),
                });
        });
    }, [
        activeHierarchyItems,
        activeItemBackgroundColor,
        activeItemBackgroundShape,
        activeItemFontColor,
        activeItemIconColor,
        backgroundColor,
        chevron,
        chevronColor,
        collapseIcon,
        disableActiveItemParentStyles,
        divider,
        expandIcon,
        hidePadding,
        itemFontColor,
        itemIconColor,
        nestedBackgroundColor,
        nestedDivider,
        ripple,
        setActiveHierarchyItems,
        children,
    ]);
    return (react_1.default.createElement(NavGroupContext_1.NavGroupContext.Provider, { value: { activeHierarchy: activeHierarchyItems } },
        react_1.default.createElement(Root, __assign({ ref: ref, "data-testid": 'blui-drawer-nav-group', className: (0, css_1.cx)(defaultClasses.root, classes.root, userClassName), subheader: variant !== 'rail' && (react_1.default.createElement(SubHeader, { className: (0, css_1.cx)(defaultClasses.subheader, classes.subheader), style: {
                    color: drawerOpen ? titleColor : 'transparent',
                } },
                title && (react_1.default.createElement(Title, { noWrap: true, variant: 'overline', className: (0, css_1.cx)(defaultClasses.title, classes.title) }, title)),
                titleContent)), backgroundColor: backgroundColor }, otherProps),
            variant !== 'rail' && (react_1.default.createElement("div", { key: "".concat(title, "_title") }, (title || titleContent) && titleDivider && react_1.default.createElement(Divider_1.default, null))),
            items.map(function (drawerItem, index) {
                if (variant === 'rail') {
                    var railItem = drawerItem;
                    if (railItem.icon === undefined) {
                        // eslint-disable-next-line no-console
                        console.warn("Missing required prop 'icon' in DrawerRailItem.");
                    }
                    return (react_1.default.createElement(DrawerRailItem_1.DrawerRailItem, { key: "itemList_".concat(index), 
                        // {...railItem}
                        // inherited props
                        activeItemBackgroundColor: (0, utilities_1.mergeStyleProp)(activeItemBackgroundColor, railItem.activeItemBackgroundColor), activeItemFontColor: (0, utilities_1.mergeStyleProp)(activeItemFontColor, railItem.activeItemFontColor), activeItemIconColor: (0, utilities_1.mergeStyleProp)(activeItemIconColor, railItem.activeItemIconColor), backgroundColor: (0, utilities_1.mergeStyleProp)(backgroundColor, railItem.backgroundColor), divider: (0, utilities_1.mergeStyleProp)(divider, railItem.divider), itemFontColor: (0, utilities_1.mergeStyleProp)(itemFontColor, railItem.itemFontColor), itemIconColor: (0, utilities_1.mergeStyleProp)(itemIconColor, railItem.itemIconColor), ripple: (0, utilities_1.mergeStyleProp)(ripple, railItem.ripple), ButtonBaseProps: railItem.ButtonBaseProps, 
                        // rail item props
                        hidden: railItem.hidden, icon: railItem.icon, itemID: railItem.itemID, onClick: railItem.onClick, statusColor: railItem.statusColor, title: railItem.title, disableRailTooltip: railItem.disableRailTooltip, sx: railItem.sx, style: railItem.style }));
                }
                // else it's a regular nav item
                var navItem = drawerItem;
                if (navItem.title === undefined) {
                    // eslint-disable-next-line no-console
                    console.warn("Missing required prop 'title' in DrawerNavItem.");
                }
                return (react_1.default.createElement(DrawerNavItem_1.DrawerNavItem, __assign({ key: "itemList_".concat(index) }, navItem, { activeItemBackgroundColor: (0, utilities_1.mergeStyleProp)(activeItemBackgroundColor, navItem.activeItemBackgroundColor), activeItemBackgroundShape: (0, utilities_1.mergeStyleProp)(activeItemBackgroundShape, navItem.activeItemBackgroundShape), activeItemFontColor: (0, utilities_1.mergeStyleProp)(activeItemFontColor, navItem.activeItemFontColor), activeItemIconColor: (0, utilities_1.mergeStyleProp)(activeItemIconColor, navItem.activeItemIconColor), backgroundColor: (0, utilities_1.mergeStyleProp)(backgroundColor, navItem.backgroundColor), chevron: (0, utilities_1.mergeStyleProp)(chevron, navItem.chevron), chevronColor: (0, utilities_1.mergeStyleProp)(chevronColor, navItem.chevronColor), collapseIcon: (0, utilities_1.mergeStyleProp)(collapseIcon, navItem.collapseIcon), disableActiveItemParentStyles: (0, utilities_1.mergeStyleProp)(disableActiveItemParentStyles, navItem.disableActiveItemParentStyles), divider: (0, utilities_1.mergeStyleProp)(divider, navItem.divider), expandIcon: (0, utilities_1.mergeStyleProp)(expandIcon, navItem.expandIcon), hidePadding: (0, utilities_1.mergeStyleProp)(hidePadding, navItem.hidePadding), itemFontColor: (0, utilities_1.mergeStyleProp)(itemFontColor, navItem.itemFontColor), itemIconColor: (0, utilities_1.mergeStyleProp)(itemIconColor, navItem.itemIconColor), nestedBackgroundColor: (0, utilities_1.mergeStyleProp)(nestedBackgroundColor, navItem.nestedBackgroundColor), nestedDivider: (0, utilities_1.mergeStyleProp)(nestedDivider, navItem.nestedDivider), ripple: (0, utilities_1.mergeStyleProp)(ripple, navItem.ripple), depth: 0, isInActiveTree: activeHierarchyItems.includes(navItem.itemID), notifyActiveParent: function (ids) {
                        if (JSON.stringify(activeHierarchyItems) !== JSON.stringify(ids)) {
                            // Sets the list of active IDs when we get a callback from an active child
                            setActiveHierarchyItems(ids.concat(navItem.itemID));
                        }
                    } })));
            }),
            getChildren())));
};
/**
 * [DrawerNavGroup](https://brightlayer-ui-components.github.io/react/components/drawer-nav-group) component
 *
 * A `<DrawerNavGroup>` is used inside of the `<DrawerBody>` to organize links/content. Each group consists of an (optional) group title and a series of navigation items. Most visual props are inherited from the `<DrawerBody>` but can be overridden at the NavGroup level if desired.
 */
exports.DrawerNavGroup = react_1.default.forwardRef(DrawerNavGroupRender);
exports.DrawerNavGroup.displayName = 'DrawerNavGroup';
// @ts-ignore
exports.DrawerNavGroup.propTypes = __assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { classes: prop_types_1.default.shape({
        title: prop_types_1.default.string,
        root: prop_types_1.default.string,
        subheader: prop_types_1.default.string,
    }), 
    // @ts-ignore
    items: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([
        prop_types_1.default.shape(__assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { icon: prop_types_1.default.element, itemID: prop_types_1.default.string.isRequired, subtitle: prop_types_1.default.string, title: prop_types_1.default.string.isRequired, onClick: prop_types_1.default.func, rightComponent: prop_types_1.default.element, statusColor: prop_types_1.default.string })),
        prop_types_1.default.shape(__assign(__assign({}, types_1.SharedStylePropTypes), { icon: prop_types_1.default.element, itemID: prop_types_1.default.string.isRequired, title: prop_types_1.default.string, onClick: prop_types_1.default.func })),
    ])), title: prop_types_1.default.string, titleColor: prop_types_1.default.string, titleContent: prop_types_1.default.element, titleDivider: prop_types_1.default.bool });
exports.DrawerNavGroup.defaultProps = {
    classes: {},
    items: [],
};
